import React from "react";
import "antd/dist/antd.css";
import styles from "./Home.module.css";
import { Typography } from "antd";
const { Title } = Typography;

export const GuestSection = ({
  setActiveState,
  setOpenKeys,
  setMenu,
  role,
}) => {
  const invokeFlicker = async () => {
    setActiveState(false);
    setOpenKeys(["sub2", "sub4", "anomaly"]);
    setMenu(true);
    /*
    for (const val in [0, 1, 2, 3, 4, 5, 6, 7]) {
      setMenu(true);
      await new Promise((resolve) => setTimeout(resolve, 150));
      setMenu(false);
      await new Promise((resolve) => setTimeout(resolve, 150));
    }
    */
  };

  return (
    <div className={styles.pageHome}>
      <Title level={3}>Welcome to CCI Dashboard</Title>
      <Title type="secondary" level={4}>
        You have logged in as {role}. Click on{" "}
        <a to="/Report" onClick={invokeFlicker}>
          Report
        </a>{" "}
        for more details.
      </Title>
    </div>
  );
};
